import React from 'react';

import { BaseProps } from '../../types';

import { ListItem, ProductLink, Wrapper } from './styles';

type Props = Pick<
  BaseProps,
  | 'className'
  | 'id'
  | 'link'
  | 'onClick'
  | 'selectable'
  | 'selected'
  | 'onDeselect'
  | 'onSelect'
  | 'isClickable'
>;

export const CompactListCard: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<Props>
>> = props => {
  const {
    className,
    id,
    link,
    onClick,
    selectable,
    selected = false,
    onDeselect = () => {},
    onSelect = () => {},
    children,
    isClickable,
  } = props;

  const handleSelect = (productId?: number) => {
    if (!productId) return;

    if (selected) {
      onDeselect();
    } else {
      onSelect();
    }
  };

  const handleOnClick = (productId?: number) => {
    if (!productId) return;
    if (onClick) onClick(productId);
  };

  return (
    <ListItem
      className={className}
      data-test="ProductCompactListCard"
      isSelectingProducts={selectable}
      key={id}
    >
      {isClickable ? (
        <ProductLink
          to={selectable ? undefined : link}
          onClick={
            selectable ? () => handleSelect(id) : () => handleOnClick(id)
          }
        >
          {children}
        </ProductLink>
      ) : (
        <Wrapper>{children}</Wrapper>
      )}
    </ListItem>
  );
};
